import FieldHandler from "./FieldHandler";
import {FORM_CLASS, INVALID_CLASS} from "../FormHandler";

export default class Checkboxes extends FieldHandler {
    public static readonly SELECTOR = '.mhp-form-field-checkboxes:has(input[type="checkbox"][data-required])'

    protected initField(el: JQuery) {
        const required = el.find('input[type="checkbox"][data-required]')
        if (required.length < 1) {
            return
        }

        required.on(`change.${FORM_CLASS}`, () => {
            if (required.is(':checked')) {
                required.removeAttr('required').prop('required', false).removeClass(INVALID_CLASS)
            } else {
                required.attr('required', 'required').prop('required', true).addClass(INVALID_CLASS)
            }
        })
        if (!required.is(':checked')) {
            required.addClass(INVALID_CLASS)
        }
    }
}
